import React from 'react'

export default function Stars({ value = '4,80', style = {} }) {
    return (
        <svg width="73" height="23" viewBox="0 0 73 23" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ ...style }}>
            <rect width="73" height="23" rx="11.5" fill="#F4F4F4" />
            <text style={{ fontFamily: 'inter', fontSize: '15px', lineHeight: '19px', fill: '#000', fontWeight: 900 }} x="34%" y="54%" textAnchor="middle" dominantBaseline="middle"> {value} </text>
            <path d="M57 2.5L59.0206 8.71885H65.5595L60.2694 12.5623L62.2901 18.7812L57 14.9377L51.7099 18.7812L53.7306 12.5623L48.4405 8.71885H54.9794L57 2.5Z" fill="#FBC42C" />
        </svg>


    )
}
